import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './AImage.module.css';
import { Picture } from './Picture';
export const AImage = ({ altText, fullWidth: isFullWidth, imageDesktop, imageMobile, isBackground, loading, className, sizes })=>{
    const description = altText ?? '';
    const renderDesktopImage = Boolean(imageDesktop?.filename && imageMobile.filename !== imageDesktop.filename);
    const pictureClassName = classNames(styles.image, isBackground && styles.fill, className);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Picture, {
                asset: imageMobile,
                className: classNames('picture-mobile', renderDesktopImage && styles['mobile-only'], pictureClassName),
                "data-testid": "image-mobile",
                description: description,
                isBackground: isBackground,
                isFullWidth: isFullWidth,
                loading: loading,
                sizes: sizes
            }),
            renderDesktopImage && /*#__PURE__*/ _jsx(Picture, {
                asset: imageDesktop,
                className: classNames('picture-desktop', styles['desktop-only'], pictureClassName),
                "data-testid": "image-desktop",
                description: description,
                isBackground: isBackground,
                isFullWidth: isFullWidth,
                loading: loading,
                sizes: sizes
            })
        ]
    });
};

//# sourceMappingURL=AImage.js.map